import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

import PaymentSelection from '@/checkout-instore-legacy/components/Payment/PaymentSelection'
import { saveContext } from '../../cart/actions'
import { actionCreators as altOrderActionCreators } from '@/checkout-instore-legacy/order/actions'
import { orderSuccessSelector } from '@/checkout-instore-legacy/order/selectors'

import { actionCreators as paymentActionCreators } from '../actions'

import {
  sellersWithoutPermissionSelector,
  paymentsPaidWithRefundSelector,
  fixedPaymentsSelector,
} from '../selectors'

const mapStateToPropsSelector = createStructuredSelector({
  fixedPayments: fixedPaymentsSelector,
  paymentsPaid: paymentsPaidWithRefundSelector,
  sellersWithoutPermission: sellersWithoutPermissionSelector,
  success: orderSuccessSelector,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...paymentActionCreators, ...altOrderActionCreators, saveContext },
    dispatch
  )

export default connect(
  mapStateToPropsSelector,
  mapDispatchToProps
)(PaymentSelection)
